import { useContext, useEffect, useState } from "react";
import { AdminDashboardContext } from "../../../../../context/AdminDashboardContext.js";
import formatNumber from "../../../../../utils/formatNumber";
import { isNumeric } from "../../../../../utils/numbers";
import "../../AdminDashboard.css";
import "./AdminTextInput.css";

const AdminTextInput = ({
  currentInputValue,
  currentLabelValue,
  projectUpdateName,
  isDate,
  isNumberInput,
  isPhoneNumberInput = false,
  reset = false,
}) => {
  const [_, setInputValue] = useState(currentInputValue);
  const [displayValue, setDisplayValue] = useState("");
  const [labelValue, setLabelValue] = useState("");

  const { projectEditable, setUpdateProjectData } = useContext(
    AdminDashboardContext
  );

  useEffect(() => {
    setLabelValue(currentLabelValue);
  }, [currentLabelValue]);

  useEffect(() => {
    if (isNumberInput) {
      if (!isNaN(currentInputValue)) {
        setInputValue(Number(currentInputValue));
        setDisplayValue(formatNumber(currentInputValue));
      }
    } else {
      setInputValue(currentInputValue);
      if (isNumeric(currentInputValue) && !isPhoneNumberInput) {
        setDisplayValue(formatNumber(currentInputValue));
      } else {
        setDisplayValue(currentInputValue);
      }
    }
  }, [currentInputValue, isDate, projectEditable, isNumberInput]);

  const handleChange = (e) => {
    const rawValue = e.target.value;
    if (isNumberInput) {
      const numericValue = rawValue.replace(/[^\d.]/g, "");

      if (!isNaN(numericValue)) {
        setInputValue(Number(numericValue));
        setDisplayValue(formatNumber(numericValue));
        setUpdateProjectData((prevState) => ({
          ...prevState,
          [projectUpdateName]: Number(numericValue),
        }));
      }
    } else {
      setInputValue(rawValue);
      setDisplayValue(rawValue);
      setUpdateProjectData((prevState) => ({
        ...prevState,
        [projectUpdateName]: rawValue,
      }));
    }
  };

  return (
    <div className="admin-text-input-container">
      {labelValue && <p className="admin-text-input-label">{labelValue}</p>}
      <input
        className="admin-text-input"
        type="text"
        readOnly={!projectEditable}
        value={projectEditable ? displayValue : displayValue}
        onChange={handleChange}
      />
    </div>
  );
};

export default AdminTextInput;
